import {SponsoredSignOff as ISponsoredSignOff} from "@proto/chatbot/v1alpha/chatbot"
import SponsoredSignOff from "./SponsoredSignOff"

interface IProps {
    message: string
}

const parse = (msg: string): ISponsoredSignOff | false => {
    try {
        return JSON.parse(msg)
    } catch (e) {
        console.error(e)
        return false
    }
}

const SponsoredSignOffMessage = ({message}: IProps) => {
    try {
        const content = parse(message)
        if (!content) {
            return
        }

        return (
            <div className="relative">
                <SponsoredSignOff content={content} />
            </div>
        )
    } catch (e) {
        return
    }
}

export default SponsoredSignOffMessage
